import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addressTitle: {
    defaultMessage: 'Ship From Address',
    id: 'CvOuNv',
    description: 'Title for the ship from address field in return details',
  },
  addressEditButtonText: {
    defaultMessage: 'Edit',
    id: 'd2MXkT',
    description: 'Text for the button that opens the edit customer address modal',
  },
});
